export default "__VITE_ASSET__c3778abb__"